import React, { useEffect, useState } from "react";
import cv from "../../../assets/cv/jawad.pdf";
import higif from "../../../assets/images/hi.gif";
import {
  FaFacebookF,
  FaGithub,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { HashLink } from "react-router-hash-link";
import { Typewriter } from "react-simple-typewriter";
const InfoPart = ({ classes }) => {
  const [count, setCount] = useState(1);
  const [currentText, setCurrentText] = useState("Web Developer");

  useEffect(() => {
    setCount(1);
  }, [count]);

  const handleTypingDone = () => {
    if (currentText === "Web Developer") {
      setCurrentText("Front End Developer");
    } else if (currentText === "Front End Developer") {
      setCurrentText("Backend Developer");
    } else if (currentText === "Backend Developer") {
      setCurrentText("Web Developer"); // To loop back to the start
    }
    setCount(0);
  };
  return (
    <div className={`${classes}`}>
      <div>
        <h6 className="text-xl md:text-sm text-center md:text-start font-roboto mb-2">
          <span className="text-white flex justify-center md:justify-start mb-2">HELLO WORLD!
            <span className="ml-2">
              <img src={higif} width="20"></img>
            </span>
          </span>
          <span className="text-white">I AM</span>
        </h6>
        <h3 className="text-4xl font-roboto font-extrabold text-white ">
          <span>Abu Nowshad Md</span>{" "}
          <span className="text-green-500">Jawad</span>
        </h3>
      </div>
      <div className=" overflow-hidden md:mb-2">
        {count ? (
          <div className="font-roboto text-3xl text-green-500 my-2">
            <Typewriter
              loop
              cursor
              cursorStyle="|"
              typeSpeed={100}
              deleteSpeed={70}
              delaySpeed={2000}
              words={[
                "Full Stack Developer",
                "Problem Solver",
                "An Enthusiast",
              ]}
            />
            {/* <Typist
              cursor={{
                element: "",
                hideWhenDone: true,
              }}
              avgTypingDelay={50}
              onTypingDone={handleTypingDone}
            >
              <span className="font-roboto text-xl text-purple-700">
                {currentText}
              </span>
              <Typist.Delay ms={800} />
              <Typist.Backspace count={20} ms={800} />
            </Typist> */}
          </div>
        ) : (
          <p></p>
        )}
      </div>

      <p className="text-white mb-2 md:mb-10 text-justify">
      My journey in competitive programming and software development began in 2017 with C and C++ for academic work and online challenges. My first project, a Java LAN chat messenger, sparked my passion for programming. Since then, I've focused on developing full-stack websites, desktop, and mobile software. I employ modern development practices, including project reporting, gathering requirements, creating ERDs, and building product and sprint backlogs.
      </p>
      <div className="flex justify-center md:space-x-5 text-lg text-white  md:justify-start py-2">
        <a href="https://www.facebook.com/anm.jawad/" target="_blank">
          <FaFacebookF className="hover:text-green-500 hover:text-white rounded-full h-8 p-1 w-8 duration-200"></FaFacebookF>
        </a>
        <a href="https://github.com/Jawad0501" target="_blank">
          <FaGithub className="hover:text-green-500 hover:text-white rounded-full h-8 p-1 w-8 duration-200"></FaGithub>
        </a>
        <a href="https://www.linkedin.com/in/abu-nowshad-md-jawad-5b0473206/" target="_blank">
          <FaLinkedinIn className="hover:text-green-500 hover:text-white rounded-full h-8 p-1 w-8 duration-200"></FaLinkedinIn>
        </a>
        <a href="https://wa.me/+8801684567037" target="_blank">
          <FaWhatsapp className="hover:text-green-500 hover:text-white rounded-full h-8 p-1 w-8 duration-200"></FaWhatsapp>
        </a>
        <a href="mailto:anmjawad007@gmail.com">
          <FiMail className="hover:text-green-500 rounded-full h-8 p-1 w-8 duration-200"></FiMail>
        </a>
      </div>
      <div className="flex space-x-1 justify-center md:justify-start mt-5 mb-10">
        <a href={cv} download="jawad.pdf" className="bg-green-600 hover:bg-opacity-70 duration-200 px-10 py-2 font-roboto text-white shadow-sm hover:shadow-md shadow-black text-xl font-bold   rounded-tl-xl rounded-bl-xl" target="_blank">
          Download CV
        </a>
        
        <HashLink
          smooth
          className="bg-green-600 hover:bg-opacity-70 px-10 py-2 duration-200 font-roboto text-white text-xl font-bold shadow-sm hover:shadow-md shadow-black rounded-tr-xl rounded-br-xl"
          to="/#skills"
        >
          My Skills
        </HashLink>
      </div>
    </div>
  );
};

export default InfoPart;
